export default {
    transferOperationType: 'Transfer Operation Type',
    transferOperationTypeTitle: 'Title',
    transferOperationTypeStatus: 'Status',
    transferOperationTypes: 'Transfer Operation Types',
    editTransferOperationType: 'Edit Transfer Operation Type',
    addTransferOperationType: 'Add Transfer Operation Type',
}